export default {"src":"/_next/static/media/in-progress.03e1bc56.svg","height":256,"width":222};